import type { DriversExportData } from './drivers-export-schema';

export const DRIVERS_EXPORT_DECIMAL_PLACES = {
  dailyRate: 2,
  mileageRate: 2,
  baseRate: 2,
  roundTripRate: 2,
  freightPercentage: 1,
} as const satisfies Partial<Record<keyof DriversExportData, number>>;
